import React from 'react';
import { FaCheckCircle, FaTimes } from 'react-icons/fa';

const SuccessMessage = ({ message, onClose }) => {
  return (
    <div className="bg-green-50 border-l-4 border-green-500 p-4 rounded mb-4">
      <div className="flex items-start">
        <FaCheckCircle className="text-green-500 mr-3 mt-0.5 flex-shrink-0" />
        <div className="flex-1">
          <p className="text-green-800 text-sm">{message}</p>
        </div>
        {onClose && (
          <button
            onClick={onClose}
            className="text-green-800 hover:opacity-75 ml-3"
          >
            <FaTimes />
          </button>
        )}
      </div>
    </div>
  );
};

export default SuccessMessage;
